import { c as _c } from "react-compiler-runtime";
import { useLayoutEffect, useRef } from 'react';
import { Metrics, FDT_METRIC_NAMES } from './Metrics';
import { useMetricsDimensions } from './metricsUtils';
import { useScrollWindowRef } from '../table/context/ScrollWindowRefContext';
import { observeVisibleLabelCells } from './observeVisibleLabelCells';

/**
 * Measures the time from tbody mount to when all visible label cells
 * (td[data-column-index="0"]) in the scroll viewport have text content.
 *
 * How it works:
 * 1. A `useLayoutEffect` fires after mount once `scrollElement` is available,
 *    and begins observing via `observeVisibleLabelCells` (which snapshots
 *    `performance.now()` as the start time internally).
 * 2. Once all visible label cells have text → report duration, disconnect.
 * 3. Safety bail at 10s → disconnect without reporting.
 */
export const useTBodyMountTimer = (pageable, pageSize) => {
  const $ = _c(4);
  const dims = useMetricsDimensions(pageable, pageSize);
  const {
    element: scrollElement
  } = useScrollWindowRef();
  const hasReported = useRef(false);
  let t0;
  let t1;
  if ($[0] !== dims || $[1] !== scrollElement) {
    t0 = () => {
      if (!scrollElement || hasReported.current) {
        return;
      }
      return observeVisibleLabelCells(scrollElement, duration => {
        hasReported.current = true;
        Metrics.timer(FDT_METRIC_NAMES.TBODY_MOUNT_TO_ALL_LABEL_CELLS_VISIBLE_TIME, dims).update(duration);
      });
    };
    t1 = [scrollElement, dims];
    $[0] = dims;
    $[1] = scrollElement;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useLayoutEffect(t0, t1);
};